import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { CompumaticClockPunchesMain } from './components/CompumaticClockPunchesMain'
import { CompumaticClockPunchesProvider } from './context/CompumaticClockPunchesProvider'
import { CompumaticClockPunchesWorkflowsProvider } from './context/CompumaticClockPunchesWorkflowsProvider'
import { EditCompumaticPunchFlow } from './workflows/EditCompumaticPunchFlow/EditCompumaticPunchFlow'

export const CompumaticClockPunches = () => {
  return (
    <NuqsAdapter>
      <CompumaticClockPunchesWorkflowsProvider>
        <CompumaticClockPunchesProvider>
          <CompumaticClockPunchesMain />
          <EditCompumaticPunchFlow />
        </CompumaticClockPunchesProvider>
      </CompumaticClockPunchesWorkflowsProvider>
    </NuqsAdapter>
  )
}
